// extracted by mini-css-extract-plugin
export default {"emailLogin":"LoginForm_emailLogin__LYNqK","loginCont":"LoginForm_loginCont__Hcbi8","socialLoginCont":"LoginForm_socialLoginCont__vxlk0"};